import { useMutation } from "@apollo/client"
import { MenuItem, Position } from "@blueprintjs/core"
import { Select } from "@blueprintjs/select"
import CustomButton from "components/Atoms/CustomButton"
import AppNavbar from "components/Molecules/AppNavbar"
import UserProfile from "components/Organisms/userprofile/UserProfile"
import { CHANGE_CURRENT_DEPARTMENT } from "graphql/auth.graphql.gql"
import useAuth from "hooks/useAuth"
import { get } from "lodash-es"
import React from "react"
// import MAINVIEW_ROUTES from "routes/mainview.routes";
import { clean } from "utils/custom.utils"
import AppHeading from "./AppHeading"

const AppHeader = () => {
  const { user } = useAuth()

  const selectDepartment = ({ id: department }) => {
    switchDepartment({ variables: { department } })
  }

  const [switchDepartment] = useMutation(CHANGE_CURRENT_DEPARTMENT, {
    onCompleted() {
      window.location.reload()
    },
  })
  const currentDepartment = get(user, "currentDepartment", {})
  const departments = get(user, "departments", [])

  function filterDepartments(query, item) {
    try {
      const regExp = new RegExp(clean(query), "i")
      if (regExp.test(clean(item.name))) return item
    } catch (err) {
      // IF Any error occurs, lets say that the user inputs a regex itself
      // Then return the item to be on the safer side
      return item
    }
  }
  return (
    <AppNavbar heading={<AppHeading />}>
      <Select
        popoverProps={{
          position: Position.BOTTOM_LEFT,
          minimal: true,
        }}
        noResults={<MenuItem key="empty" disabled={true} text="No results." />}
        itemPredicate={filterDepartments}
        filterable={departments && departments.length > 5 ? true : false}
        items={departments}
        itemRenderer={(dept, { handleClick, modifiers }) => (
          <MenuItem
            className="vt-header-selector-menu"
            key={dept.id}
            active={modifiers.active}
            text={dept.name}
            onClick={handleClick}
            labelElement={<img alt={dept.name} src={dept.photo} />}
          />
        )}
        onItemSelect={selectDepartment}
      >
        <CustomButton
          data-testid="department-dropdown"
          icon={
            currentDepartment ? (
              <img
                className="vt-selector-image"
                src={currentDepartment.photo}
                alt={currentDepartment.name}
              />
            ) : null
          }
          rightIcon="caret-down"
          text={
            currentDepartment && currentDepartment.name
              ? currentDepartment.name
              : "Select Department"
          }
        />
      </Select>
      <UserProfile />
    </AppNavbar>
  )
}

export default AppHeader
